import { Checkbox, Form, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import Button from '../../../components/Button/Button';
import FormItem from '../../../components/FormItem/FormItem';
import Input from '../../../components/Input/Input';
import { useNavigate  } from 'react-router-dom';

import styles from './Register.module.scss';
import { createErrorNotification, createSuccessNotification } from '../../../service/notification';
import { registerUser } from '../../../service/user';
import { performLogin } from '../../../service/auth';
import { saveOnLocalStorage } from '../../../utils/local-storage';
import Icon from '../../../components/Icon/Icon';
import { Login } from '../../../models/auth';
import { useUserStore } from '../../../store/useUser';

import { validateEmail } from '../../../service/share';
import { useSidebarStore } from '../../../store/useSidebar';
import useHeader from '../../../hooks/useHeader';

const isEmail = (value) => {
  const testEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)

  if (!testEmail) return false

  return true
}

const Register = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [buttonName, setButtonName] = useState("Criar conta");

  const setJwt = useUserStore((state) => state.setJwt);
  const setUserId = useUserStore((state) => state.setUserId);
  const setMenu = useSidebarStore(state=> state.setMenu)
  const setProfile = useUserStore((state) => state.setProfile);

  useHeader({ header: 'Cadastro' });

  async function onFinish(payload: Login){
    if(loading) return

    setLoading(true)

    const { error: errorEmail } = await validateEmail(payload.email);

    if(errorEmail){
      setLoading(false)
      return createErrorNotification("Email já está em uso");
    }

    const {error, success} = await registerUser(payload);
    setButtonName("Registrado!")

    if(error) {
      setLoading(false)

      return createErrorNotification('Ops, algo deu errado no cadastro. Tente novamente mais tarde.');
    }

    const {email,password} = payload;
    setButtonName("Aguarde ...")

    const {error: errorLogin, success: jwt} = await performLogin({email,password});

    if(errorLogin) {
      setLoading(false);

      return createErrorNotification("Ops, parece que algo deu errado. Você terá que logar manualmente")
    } 
    
    if(!jwt) {
      setLoading(false);

      createErrorNotification("Ops, parece que algo deu errado. Você terá que logar manualmente")
      return
    }  

    setJwt(jwt)

    setUserId(jwt.user);
    
    saveOnLocalStorage('jwt', jwt);

    setProfile('Clubista')

    setLoading(false)

    setMenu();

    navigate(`/user/${jwt.user}`);
  }

  return(
    <div className={styles.container}>
      <div className={styles.maskContainer}></div>
        <div className={styles.createContainer}>
          <div className={styles.createForm}>
            <Form 
              layout="vertical" 
              onFinish={onFinish} 
              hideRequiredMark 
              id="formLogin" 
              className={styles.FormContainer}
            >
              <h2 className={styles.title}>Criar conta</h2>
              <FormItem
                label="Nome completo"
                name="fullname"
                required
                rules={[
                  {
                    required: true, 
                    message: 'Por favor, insira seu nome!'
                  }
                ]}
                >
                  <Input style={styles.input}/>
                </FormItem>
                <FormItem
                  label="Email"
                  name="email"
                  required
                  rules={[
                    {
                      required: true, message: 'Por favor, insira seu email!',
                    },
                    {
                      validateTrigger: 'onBlur',
                      validator: async (_, value) => {
                        if (!value) return

                        const testEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)

                        if (!testEmail) {
                          return Promise.reject(new Error('Por favor, insira um email válido!'));
                        }

                        setLoading(true)

                        const { error, success } = await validateEmail(value)

                        setLoading(false)

                        if (error) return Promise.reject(new Error('Email já está em uso'));
                      }
                    }
                  ]}
                >
                  <Input 
                    style={styles.input} 
                    type="email"
                    />
                </FormItem>
                <FormItem
                  label="Senha"
                  name="password" 
                  required
                  rules={[
                    {
                      required: true, 
                      message: 'Por favor, defina a senha!'
                    }
                  ]}
                >
                  <Input style={styles.input} type="password" />
                </FormItem>
                <FormItem
                  label="Confirmar senha"
                  name="passwordConfirm"
                  required
                  dependencies={['password']}
                  rules={[
                    {
                      required: true, 
                      message: 'Por favor, confirme a senha!'
                    },
                    ({ getFieldValue }) => ({
                      validateTrigger: ['onBlur', 'onChange'],
                      validator(_, value){
                        const password = getFieldValue('password')

                        if (!value || password === value) {
                          return Promise.resolve();
                        }


                        if (value !== password) return Promise.reject(new Error('Senhas não coincidem.'));
                      }
                    })
                  ]}
                >
                  <Input style={styles.input} type="password" />
                </FormItem>
                <Button loading={loading} submit style={styles.button}>{buttonName}</Button>
              </Form>
              <div className={styles.redirectLink}>
                Já tem uma conta? <a href="/login" className={styles.link}>Faça o login.</a>
              </div>
            </div>
        </div>
    </div>
  )
}

export default Register;